export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7250.59a21ca2.jpg";